export default __webpack_public_path__ + "static/media/Pistol_5.813fe214.png";